'use client';

import { c as _c } from "react/compiler-runtime";
import PlayCircleIcon from '@/app/[locale]/(worlds)/[roomId]/components/PlayCircleIcon';
import { useMobilePlayMediaLink } from '@/hooks/useMobilePlayMediaLink';

/** Centred play icon over the portrait media for the `icon-only` experiment arm. */
export default function WorldPlayIconOverlay() {
  const $ = _c(5);
  const playLink = useMobilePlayMediaLink();
  if (!playLink?.isIconOnly) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PlayCircleIcon className="shadow-background/60 size-20 border-2 border-white bg-white/85 shadow-lg backdrop-blur-sm" triangleClassName="size-10" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== playLink.captureAttributes || $[2] !== playLink.label || $[3] !== playLink.onPlay) {
    t1 = <div className="z-interactive pointer-events-none absolute inset-0 flex items-center justify-center"><div role="button" aria-label={playLink.label} onClick={playLink.onPlay} data-bi-key="world_mobile_play" {...playLink.captureAttributes} className="pointer-events-auto flex size-20 cursor-pointer items-center justify-center">{t0}</div></div>;
    $[1] = playLink.captureAttributes;
    $[2] = playLink.label;
    $[3] = playLink.onPlay;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}